import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import Button from 'src/components/Button';
import djangoContextHelper from 'src/utils/django-context-helper';
import HorizontalScrollContainer from 'src/components/HorizontalScrollContainer';
import Icons from 'src/components/Icons';
import PageLayout from 'src/components/layouts/PageLayout';
import ProgressiveImage from 'src/components/ProgressiveImage';
import { commonNamespaces } from 'src/utils/setUpTranslation';
import { renderPage } from 'src/utils/PageTemplate';

import styles from './Index.module.scss';

const HomePage = () => {
  const { t } = useTranslation('index');
  const coaches = ['mae', 'hanyu', 'morosa', 'anew'];
  const { user } = djangoContextHelper();
  return (
    <>
      <Helmet>
        <title>Moving Studio</title>
      </Helmet>
      <PageLayout>
        <div className={styles.container}>
          <div className={styles.sec1}>
            <div className={styles.left}>
              <div className={styles['img-container']}>
                <ProgressiveImage
                  urls={[
                    '/static/assets/img/index/sec1-l-s.png',
                    '/static/assets/img/index/sec1-l-m.png',
                    '/static/assets/img/index/sec1-l.jpg',
                  ]}
                />
                <div className={styles.title}>{t('sec1-title')}</div>
                <a href="https://www.moving-studio.shop/collections/new-member-free-trial-american-style-indoor-cycling">
                  <Button className={styles.btn}>{t('join-now')}</Button>
                </a>
              </div>
            </div>
            <div className={styles.right}>
              <a href="https://www.moving-studio.shop/collections/american-style-indoor-cycling" target="_blank">
                <div className={styles['img-container']}>
                  <ProgressiveImage
                    urls={[
                      '/static/assets/img/index/sec1-r-s.png',
                      '/static/assets/img/index/sec1-r-m.png',
                      '/static/assets/img/index/sec1-r.jpg',
                    ]}
                  />

                  <div className={styles.title}>{t('buy-now')}</div>
                  <Icons.ArrowRb className={styles.arrow} />
                </div>
              </a>
              <a className={styles.booking} href="/schedule">
                <div className={styles.title}>{t('course-booking')}</div>
                <Icons.ArrowRb className={styles.arrow} />
              </a>
            </div>
          </div>
          <div className={styles.sec2}>
            <div className={styles.left}>
              <div className={styles.title}>{t('benefit-of-cycling')}</div>
              <div className={styles.desc}>{t('benefits')}</div>
            </div>
            <div className={styles.right}>
              <div className={styles['img-container']}>
                <ProgressiveImage
                  urls={[
                    '/static/assets/img/index/sec2-s.png',
                    '/static/assets/img/index/sec2-m.png',
                    '/static/assets/img/index/sec2.jpg',
                  ]}
                />
              </div>
            </div>
          </div>
          <div className={styles.sec3}>
            <div className={styles.block}>
              <div className={styles['img-container']}>
                <ProgressiveImage
                  urls={[
                    '/static/assets/img/index/sec3-1-s.png',
                    '/static/assets/img/index/sec3-1-m.png',
                    '/static/assets/img/index/sec3-1.jpg',
                  ]}
                />
                <div className={styles.title}>{t('500cal-45mins')}</div>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles['img-container']}>
                <ProgressiveImage
                  urls={[
                    '/static/assets/img/index/sec3-2-s.png',
                    '/static/assets/img/index/sec3-2-m.png',
                    '/static/assets/img/index/sec3-2.jpg',
                  ]}
                />
                <div className={styles.title}>{t('60mins')}</div>
                <div className={styles.sub}>{t('in-and-out-in-60mins')}</div>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles['img-container']}>
                <ProgressiveImage
                  urls={[
                    '/static/assets/img/index/sec3-3-s.png',
                    '/static/assets/img/index/sec3-3-m.png',
                    '/static/assets/img/index/sec3-3.jpg',
                  ]}
                />
                <div className={styles.title}>
                  <Icons.Music className={styles.icon} />
                </div>
                <div className={styles.sub}>{t('various-music')}</div>
              </div>
            </div>
          </div>
          <div className={styles['sec4-head']}>
            <div className={styles.title}>{t('our-team')}</div>
            {/* <a className={styles.link} href="/team">
                {t('see-all')}
              </a> */}
          </div>
          <div className={styles.sec4}>
            <HorizontalScrollContainer className={styles.scroller}>
              <div className={styles.coaches}>
                {coaches.map((coach) => (
                  <div className={styles.card} key={coach}>
                    <div className={styles['img-container']}>
                      <ProgressiveImage
                        urls={[
                          `/static/assets/img/coach/${coach}-1-s.png`,
                          `/static/assets/img/coach/${coach}-1-m.png`,
                          `/static/assets/img/coach/${coach}-1.jpg`,
                        ]}
                      />
                      <div className={styles.title}>
                        <span>
                          <Icons.Bike className={styles.icon} />
                          {t('trainer')}
                        </span>
                        <br />
                        <span className={styles.name}>{coach}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </HorizontalScrollContainer>
          </div>
          <div className={styles.sec5}>
            <ProgressiveImage
              className={styles.img}
              urls={[
                '/static/assets/img/index/sec5-s.png',
                '/static/assets/img/index/sec5-m.png',
                '/static/assets/img/index/sec5.jpg',
              ]}
            />
            <div className={styles.title}>{t('join-us-content')}</div>
            <a href={user ? '/user' : '/user/sign-up'}>
              <Button className={styles.btn}>{t('join-us')}</Button>
            </a>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

renderPage(HomePage, [...commonNamespaces, 'index']);

export default HomePage;
